/**
 * Category metadata — single source of truth for the /tools hub filter
 * chips and tool-card eyebrows. Each entry maps a backend category key
 * (e.g., "water_intrusion") to a Title-Case label (no underscores) plus a
 * lucide-react icon component.
 *
 * Why this file: ToolsHub and CalculatorPage previously hard-coded labels
 * in two places, and category strings appeared with underscores in the
 * UI (e.g., "water_intrusion"). Centralizing here fixes the spelling +
 * adds icons in one place.
 */
import {
    Handshake,           // negotiation
    Wallet,              // costs
    HelpCircle,          // decision
    Wrench,              // specialty / generic
    LandPlot,            // foundation
    Droplets,            // water_intrusion
    Home as HomeIcon,    // roofing
    Wind,                // hvac
    Zap,                 // electrical
    PipetteIcon,         // plumbing
    Flame,               // chimney
} from "lucide-react";

export const CATEGORY_META = {
    negotiation:     { label: "Negotiation",       Icon: Handshake },
    costs:           { label: "Repair Costs",      Icon: Wallet },
    decision:        { label: "Decision Support",  Icon: HelpCircle },
    specialty:       { label: "Specialty",         Icon: Wrench },
    foundation:      { label: "Foundation",        Icon: LandPlot },
    water_intrusion: { label: "Water Intrusion",   Icon: Droplets },
    roofing:         { label: "Roofing",           Icon: HomeIcon },
    hvac:            { label: "HVAC",              Icon: Wind },
    electrical:      { label: "Electrical",        Icon: Zap },
    plumbing:        { label: "Plumbing",          Icon: PipetteIcon },
    chimney:         { label: "Chimney",           Icon: Flame },
};

/** Title-Case fallback for any category not in the registry. */
export function categoryLabel(key) {
    if (!key) return "Tool";
    if (CATEGORY_META[key]) return CATEGORY_META[key].label;
    return key
        .split(/[_\s]+/)
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(" ");
}

export function categoryIcon(key) {
    return CATEGORY_META[key]?.Icon || Wrench;
}
